var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,{tag:"component"},[(_vm.useDotNav)?_c('dot-nav',{attrs:{"anchors":_vm.anchors,"activeAnchor":_vm.activeAnchor}}):_vm._e(),_vm._v(" "),_vm._t("default",null,{anchors:_vm.anchors})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04fa9919","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnchorNav/AnchorContainer.vue
// module id = null
// module chunks = 